<template>
  <v-app>
    <v-main>
      <DefaultLayout>
        <router-view/>
      </DefaultLayout>
    </v-main>
  </v-app>
</template>

<script>

import DefaultLayout from "@/layout/default";
export default {
  name: 'App',
  components: {DefaultLayout},
  data: () => ({
    //
  }),
};
</script>
